import { useAppDispatch, useAppSelector } from '@redux/hooks';
import {
	addAppliedFilterPillOptions,
	commitAppliedFilterPillChanges,
	modifyApplied,
	modifySelected,
} from '@redux/search/actions';
import { useCallback } from 'react';
import { afterNextPaint } from '../../../../helpers/after-next-paint';

export const useApplyFacet = () => {
	const dispatch = useAppDispatch();
	const filters = useAppSelector((state) => state.search.filters.filters);
	const sidebarSelected = useAppSelector(
		(state) => state.search.filterPills.sidebar.selected,
	);
	const sidebarApplied = useAppSelector(
		(state) => state.search.filterPills.sidebar.applied,
	);
	const getFacetToApply = useCallback(
		(facetId: string) => {
			const filter = filters.find((f) =>
				f.filterOptions.some((o) => o.id === facetId),
			);
			const option = filter?.filterOptions.find((o) => o.id === facetId);
			if (!filter || !option) {
				return null;
			}
			return {
				id: facetId || '',
				categorySlug: filter.slug,
				name: option.name,
				value: option.singular.slug,
			};
		},
		[filters],
	);

	return useCallback(
		(facetId: string) => {
			afterNextPaint(() => {
				const facet = getFacetToApply(facetId);
				if (!facet) return;
				dispatch(addAppliedFilterPillOptions([facet]));
				dispatch(modifySelected([facet.id, ...sidebarSelected]));
				dispatch(modifyApplied([facet, ...sidebarApplied]));
				dispatch(commitAppliedFilterPillChanges());
			});
		},
		[dispatch, getFacetToApply, sidebarApplied, sidebarSelected],
	);
};
